import useAvailabilityTick from "../../hooks/useAvailabilityTick";
import { getProductAvailability } from "../../lib/preorder";
import { PREORDER_DAYS_RANGE } from "../../lib/preorderLeadTime";

// Mono microcopy below a product's status chip.
// Colour follows the chip: olive under IN STOCK, accent under PRE-ORDER.
// Re-renders every 60s via useAvailabilityTick so a stale tab across midnight
// picks up the new dispatch window automatically.
export default function DispatchLine({ variant, tags = [], className = "", ...rest }) {
  // eslint-disable-next-line no-unused-vars
  const _tick = useAvailabilityTick();
  const info = getProductAvailability(variant, tags, new Date());
  const isPre = info.status === "PRE_ORDER";
  // Colors come from CSS vars so they flip automatically for dark theme
  // (see --dispatch-preorder / --dispatch-instock in index.css).
  const color = isPre ? "var(--dispatch-preorder)" : "var(--dispatch-instock)";

  return (
    <div
      className={"font-mono text-[11px] leading-snug " + className}
      style={{ color }}
      {...rest}
    >
      {isPre ? (
        <>
          <div className="uppercase tracking-[0.04em]">ESTIMATED DISPATCH: {PREORDER_DAYS_RANGE} DAYS</div>
          <div className="uppercase tracking-[0.04em] opacity-95">{info.dispatchRange}</div>
        </>
      ) : (
        <div className="uppercase tracking-[0.04em]">SHIPS IN 2–4 BUSINESS DAYS</div>
      )}
    </div>
  );
}
